import { createAtom } from '../../../utils/recoil'
import { HoveredItem } from './types'

const prefix = 'Map/HoveredItems'

export const hoveredItemsState = createAtom<HoveredItem[]>({
  key: 'hoveredItems',
  prefix,
  default: [],
})
